import { FC } from 'react'
import { ArrowPathIcon } from '@heroicons/react/24/outline'
import { RocketLaunchIcon } from '@heroicons/react/24/outline'
import { CgSpinner } from 'react-icons/cg'

import { classNames } from '@/utils'

import {
  OPS_BULK_CLEAR_CACHE_LABEL,
  OPS_BULK_CLEAR_CACHE_TOOLTIP,
  OPS_BULK_REDEPLOY_LABEL,
  OPS_BULK_REDEPLOY_TOOLTIP,
  OPS_BULK_REFRESH_LABEL,
  OPS_BULK_REFRESH_LOADING_LABEL,
  OPS_BULK_REFRESH_TOOLTIP,
  OPS_BUTTON_ICON_CLASS,
  CardActionButtonContent,
  ClearCacheIcon,
  cardActionButtonClass,
  iconHoverClass,
} from './opsUiShared'

type GroupBulkActionButtonsProps = {
  disabled?: boolean
  onRedeploy: () => void
  onClearCache: () => void
  onRefresh?: () => void
  isRefreshing?: boolean
  refreshDisabled?: boolean
  className?: string
  /** Prevent click from bubbling (e.g. inside clickable card) */
  stopPropagation?: boolean
}

const GroupBulkActionButtons: FC<GroupBulkActionButtonsProps> = ({
  disabled = false,
  onRedeploy,
  onClearCache,
  onRefresh,
  isRefreshing = false,
  refreshDisabled = false,
  className,
  stopPropagation = false,
}) => (
  <div
    className={classNames('flex flex-wrap items-center gap-2', className)}
    onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
  >
    {onRefresh && (
      <button
        type="button"
        className={cardActionButtonClass('gray')}
        disabled={refreshDisabled}
        title={OPS_BULK_REFRESH_TOOLTIP}
        aria-label={OPS_BULK_REFRESH_TOOLTIP}
        onClick={onRefresh}
      >
        <CardActionButtonContent
          icon={
            isRefreshing ? (
              <CgSpinner className={classNames(OPS_BUTTON_ICON_CLASS, 'animate-spin')} />
            ) : (
              <ArrowPathIcon
                className={classNames(OPS_BUTTON_ICON_CLASS, iconHoverClass)}
              />
            )
          }
          label={isRefreshing ? OPS_BULK_REFRESH_LOADING_LABEL : OPS_BULK_REFRESH_LABEL}
        />
      </button>
    )}
    <button
      type="button"
      className={cardActionButtonClass('green')}
      disabled={disabled}
      title={OPS_BULK_REDEPLOY_TOOLTIP}
      aria-label={OPS_BULK_REDEPLOY_TOOLTIP}
      onClick={(e) => {
        e.stopPropagation()
        onRedeploy()
      }}
    >
      <CardActionButtonContent
        icon={
          <RocketLaunchIcon
            className={classNames(OPS_BUTTON_ICON_CLASS, iconHoverClass)}
          />
        }
        label={OPS_BULK_REDEPLOY_LABEL}
      />
    </button>
    <button
      type="button"
      className={cardActionButtonClass('red')}
      disabled={disabled}
      title={OPS_BULK_CLEAR_CACHE_TOOLTIP}
      aria-label={OPS_BULK_CLEAR_CACHE_TOOLTIP}
      onClick={(e) => {
        e.stopPropagation()
        onClearCache()
      }}
    >
      <CardActionButtonContent
        icon={
          <ClearCacheIcon
            className={classNames(OPS_BUTTON_ICON_CLASS, iconHoverClass)}
          />
        }
        label={OPS_BULK_CLEAR_CACHE_LABEL}
      />
    </button>
  </div>
)

export { GroupBulkActionButtons }
